/*
* Configuration for Search
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()

  return {
    widgets: [
      {
        widgetId: 'PagesAnnouncementBanner',
        widgetEnable: true,
        data: {
          title: i18n?.t('searchProductsTitle'),
          bgImage: null,
          externalReviews: {
            enable: true,
            optional: true
          },
          flex: ['s12 l6', 's12 l6'],
          parentClasses: 'grey lighten-2',
          clients: {
            label: i18n?.t('trustedByTopBrands'),
            enable: true,
            showRandom: true,
            randomCount: 5
          }
        }
      },
      {
        widgetId: 'Breadcrumbs',
        widgetEnable: true,
        data: {
          parentClasses: 'grey lighten-3 py-6'
        }
      },
      {
        widgetId: 'SystemProducts',
        widgetEnable: true,
        data: {
          parentClasses: 'bg-gray-50 pb-12 xl:pb-16',
          parentStyle: 'secondStyle',
          showLabel: true,
          productCard: {
            cardWidgetId: false,
            cardWidgetPlaceholderId: false,
            aspectSquare: false,
            showColors: true,
            showBadges: true,
            showLabel: true,
            showPrice: true,
            isLargeCardSecondStyle: false,
            isLargeCardShowBanner: false
          },
          filters: {
            widgetEnable: true,
            parentClasses: 'pt-0',
            elementClassesFirst: 'pt-12 xl:pt-16',
            elementClassesSecond: 'pt-12 xl:pt-16',
            headline: false,
            searchEnable: true,
            viewTypeEnable: true,
            filterByPriceEnable: false,
            filteringEnable: true,
            items: false
          },
          products: {
            parentClasses: 'pt-6 lx:pt-8',
            categoryPathname: 'products',
            limit: 26,
            gap: 4,
            defaultElClasses: 'w-full md:w-1/2 lg:w-1/3',
            gridClasses: '-mx-2 md:-mx-4',
            elClasses: 'p-2 md:p-4',
            grid: false
          }
        }
      },
      {
        widgetId: 'PagesBannerTitleDescrButton',
        widgetEnable: true,
        data: {
          enableWidget: true,
          parentClasses: 'base-section',
          title: i18n?.t('widgets.PagesBannerTitleDescrButtonSearch.title'),
          descr: i18n?.t('widgets.PagesBannerTitleDescrButtonSearch.descr'),
          buttonTitle: i18n?.t('contactUs'),
          link: '/page/contact-92/#feedback'
        }
      },
      {
        widgetId: 'PagesReviewsAndClients',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm white lighten-3',
          label: i18n?.t('reviews'),
          title: i18n?.t('customersLoveUs'),
          titleSecond: i18n?.t('trustedByTheBest'),
          clients: [
            {
              id: 'amc',
              classes: ''
            },
            {
              id: 'american-crew',
              classes: 'hide-on-med-only'
            },
            {
              id: 'baxter',
              classes: ''
            },
            {
              id: 'bentley',
              classes: ''
            },
            {
              id: 'csx',
              classes: ''
            },
            {
              id: 'fiat',
              classes: ''
            },
            {
              id: 'google',
              classes: ''
            },
            {
              id: 'hbo',
              classes: ''
            },
            {
              id: 'harley-davidson',
              classes: 'hide-on-med-only'
            },
            {
              id: 'ktm',
              classes: ''
            },
            {
              id: 'microsoft',
              classes: ''
            },
            {
              id: 'heineken',
              classes: ''
            },
            {
              id: 'nike',
              classes: ''
            },
            {
              id: 'motorola',
              classes: ''
            },
            {
              id: 'puma',
              classes: 'hide-on-med-only'
            }
          ]
        }
      },
      {
        widgetId: 'PagesHtmlContent',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm',
          content: i18n?.t('widgets.PagesHtmlContentSearch.content')
        }
      },
      {
        widgetId: 'PagesOurDifference',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm'
        }
      }
    ]
  }
}
